var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4",
    "data-name": "Group 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.282,
    height: 26.292,
    viewBox: "0 0 26.282 26.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M-574.955,148.058v19.407c-.017.065-.039.128-.051.194a3.736,3.736,0,0,1-2.131,2.848,8.8,8.8,0,0,1-1.257.4h-6.622v-9.3h3.9l.771-4.628H-585v-3.126h4.639v-4.617c-1.533,0-3.046,0-4.56,0a4.624,4.624,0,0,0-4.711,4.713c0,.915,0,1.831,0,2.747v.3H-592.7v4.615h3.067v9.29H-597.8a.7.7,0,0,0-.119-.043,3.835,3.835,0,0,1-3.318-3.86q-.008-9.24.007-18.479a4.145,4.145,0,0,1,.206-1.282,3.809,3.809,0,0,1,3.741-2.622q8.712,0,17.423,0c.393,0,.788-.017,1.18.007a3.731,3.731,0,0,1,3.31,2.15A8.332,8.332,0,0,1-574.955,148.058Z",
    transform: "translate(601.238 -144.612)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7f31969196542ba0f3bbe59fe2faae96.svg";
export { ForwardRef as ReactComponent };